import RouteTemplate from 'ember-route-template'

import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import { ErrorsImage404 } from 'teacher-ui-client/components/errors/image-404'
import { ErrorsButtonHome } from 'teacher-ui-client/components/errors/button-home'

export const Errors404Page: TOC<unknown> = <template>
  <div data-test-subscription-type-404 class="text-dusty-black-300 mx-auto my-8 max-w-xl space-y-2 text-center">
    <ErrorsImage404 />
    <h2 data-test-404-title>
      {{t "components.errors.404Page.title"}}
    </h2>
    <p class="text-xl" data-test-404-body>
      {{t "components.errors.404Page.body" htmlSafe=true}}
    </p>
    <div class="p-2">
      <ErrorsButtonHome />
    </div>
  </div>
</template>

export default RouteTemplate(Errors404Page)
